import { render, staticRenderFns } from "./LayoutPrivate.vue?vue&type=template&id=4d7412e2&scoped=true&lang=html&"
import script from "./LayoutPrivate.vue?vue&type=script&lang=js&"
export * from "./LayoutPrivate.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPrivate.vue?vue&type=style&index=0&id=4d7412e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7412e2",
  null
  
)

export default component.exports